import React, { useEffect, useState } from 'react';

import { getChannelGroupsPromise } from '~/src/dash/api/channel-group';
import { IChannelGroup } from '~/src/dash/api/console-api';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';

interface IChannelGroupSelectProps {
  name: string;
  onChange: (elem: React.ChangeEvent) => void;
  publisherID: string;
  value: IChannelGroup[];
  disabled: boolean;
  helperText?: string;
  menuTitleOverride?: string;
}

export const ChannelGroupTargetingMultiSelect = function ({
  onChange,
  disabled,
  name,
  value = [],
  publisherID,
  helperText,
  menuTitleOverride,
}: IChannelGroupSelectProps) {
  const [channelGroupMenuList, setChannelGroupMenuList] = useState<IMenuList>({});
  const [channelGroups, setChannelGroups] = useState<IChannelGroup[]>([]);

  async function loadChannelGroups() {
    try {
      const channelGroups: IChannelGroup[] = await getChannelGroupsPromise({
        publisherID,
      }).then(({ channelGroups }: { channelGroups: IChannelGroup[] }) => channelGroups);
      setChannelGroups(channelGroups);
      setChannelGroupMenuList(buildChannelGroupMenuList(channelGroups, value));
    } catch (e) {
      setChannelGroupMenuList({});
    }
  }

  function handleMenuSelectionDone(values: IMenuList) {
    const segmentIdStringIDs = Object.values(values)
      .filter((src: IListItem) => {
        return src.selected;
      })
      .map((src: IListItem) => src.ID);

    const selectedSegments = channelGroups.filter((channelGroup) =>
      segmentIdStringIDs.includes(channelGroup.ID.toString()),
    );

    onChange({
      target: {
        name,
        value: selectedSegments,
      },
    } as any);
  }

  useEffect(() => {
    loadChannelGroups();
  }, [publisherID]);

  return (
    <MaterialSearchDropdownMulti
      getValueFromSearchElement={(src: IListItem) => src.title}
      selectAll={true}
      menuTitle='Channel Groups'
      menuTitleOverride={menuTitleOverride}
      list={channelGroupMenuList}
      disabled={disabled}
      onChange={setChannelGroupMenuList}
      handleMenuAcceptClick={handleMenuSelectionDone}
      isNoneSelectedAllSelected={false}
      helperText={helperText}
    />
  );
};

function buildChannelGroupMenuList(
  channelGroups: IChannelGroup[],
  selectedChannelGroups: IChannelGroup[],
): IMenuList {
  const list = {} as IMenuList;
  const selectedIDs = selectedChannelGroups.map((channelGroup) => channelGroup.ID);

  channelGroups.forEach((channelGroup) => {
    list[channelGroup.ID] = {
      title: channelGroup.Name,
      ID: channelGroup.ID.toString(),
      selected: selectedIDs.includes(channelGroup.ID),
    } as IListItem;
  });
  return list;
}
